import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { EMPLOYEE_API } from "./apiRoutes";

const mutateUpdateEmployee = async ({
  id,
  data,
}: {
  id: string;
  data: FieldValues;
}) => {
  return await axiosAuth.patch(`${EMPLOYEE_API}/${id}`, data);
};

const useUpdateEmployeeMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateEmployee,
    ...queryParams,
  });

export default useUpdateEmployeeMutation;
